export default "__VITE_ASSET__5TDinx4P__"